export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMy4wNCAyMy43NSI+PGRlZnM+PHN0eWxlPi5ncmFtbWFyLWNscy0xe2ZpbGw6IzU1NWZmZjtzdHJva2U6IzExOTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBpZD0iUGF0aF8xMTMiIGRhdGEtbmFtZT0iUGF0aCAxMTMiIGNsYXNzPSJncmFtbWFyLWNscy0xIiBkPSJNMzIsMSwxNi40MSw2LjYzSDIuNzFMMSwyMi43NUgxOC4xTDE2LjQxLDYuODkiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/grammar.svg
// module id = 283
// module chunks = 0 7 11